// src/components/TextInput.js
import React from 'react';

function TextInput({ label, name, value, onChange, type = 'text' }) {
  return (
    <div style={{ marginBottom: '1rem' }}>
      <label htmlFor={name}>{label}</label>
      <br />
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        style={{ width: '100%', padding: '8px' }}
      />
    </div>
  );
}

export default TextInput;
